import { useEnableDisableUserMutation } from '@/generated/graphql';
import { ICashierTable } from '@/shared/interfaces';

import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import Modal from 'react-modal';

interface IProp {
  data: ICashierTable | undefined;
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: () => void;
}

export function EnableDisableCashier(props: IProp) {
  const { data, isOpen, setOpen, refetch } = props;

  const [enableDisableUserMutation] = useEnableDisableUserMutation();

  const handleClose = () => setOpen(false);

  const toggle = (trigger: boolean) => {
    enableDisableUserMutation({
      variables: {
        input: {
          userId: data?.id ?? '',
          status: trigger,
        },
      },
      onCompleted() {
        refetch();
      },
    });

    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
        },
        content: {
          position: 'absolute',
          margin: '0.1% auto',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          padding: 0,
          marginRight: '-50%',
          transform: 'translate(-50%, -48vh)',
          border: '0px',
          background: 'transparent',
          WebkitOverflowScrolling: 'touch',
          borderRadius: '4px',
          outline: 'none',
        },
      }}>
      <Box
        sx={{
          backgroundColor: '#fff',
          width: 450,
          height: 350,
        }}>
        <Divider
          sx={{
            height: '25px',
            backgroundColor: '#87ADD4',
          }}
        />
        <Box p={1} mt={5}>
          <Typography
            sx={{
              textAlign: 'center',
            }}
            id="modal-modal-title"
            variant="h3"
            component="h3">
            {data?.isDisabled ? <>Enable Cashier?</> : <>Disable Cashier?</>}
          </Typography>
          <Box m={9}>
            <Grid container spacing={1}>
              <Grid alignItems={'center'} alignContent="center" size={6}>
                <Button
                  sx={{
                    width: '100%',
                  }}
                  onClick={() => {
                    toggle(!data?.isDisabled);
                  }}>
                  <Box
                    sx={{
                      backgroundColor: '#427FC1',
                      color: '#fff',
                      width: '100%',
                    }}
                    p={1}>
                    Yes
                  </Box>
                </Button>
              </Grid>
              <Grid size={6}>
                <Button
                  sx={{
                    width: '100%',
                  }}
                  onClick={handleClose}>
                  <Box
                    sx={{
                      backgroundColor: '#8E0A0E',
                      color: '#fff',
                      width: '100%',
                    }}
                    p={1}>
                    No
                  </Box>
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
